import { Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { redirectToCentralizedLogin } from '@/auth/silentRefresh';
import { StandaloneFrame } from '@/shell/StandaloneFrame';

export function AuthError() {
  const { t } = useTranslation();
  return (
    <StandaloneFrame>
      <Typography variant="h1" gutterBottom>
        {t('auth.errorTitle')}
      </Typography>
      <Typography variant="body1" sx={{ mb: 3 }}>
        {t('auth.errorBody')}
      </Typography>
      <Button variant="contained" onClick={() => redirectToCentralizedLogin('/')}>
        {t('auth.tryAgain')}
      </Button>
    </StandaloneFrame>
  );
}
